import { fetchCohort, fetchCohorts } from "../../services";

export const cohortsQuery = (activeTab: "active" | "archived") => {
	const normalizedTab = activeTab || "active";
	return {
		queryKey: ["cohorts", normalizedTab],
		queryFn: () => fetchCohorts(normalizedTab),
		meta: {
			errorMessage: "There was an error getting the cohorts.",
		},
	};
};

export const cohortQuery = (cohortID: string) => ({
	queryKey: ["cohort", cohortID],
	queryFn: () => fetchCohort(cohortID),
	meta: {
		errorMessage: "There was an error getting the cohort.",
	},
});
